import * as CookieConsent from 'vanilla-cookieconsent';
import type { ConsentParams } from '~/shared/types';
import persistAndEmitConsentFromCookie from '../persistAndEmitConsentFromCookie';

type Args = {
  storageKey: string;
  setConsentState: (consent: ConsentParams) => void;
  setHasStoredConsent: (value: boolean) => void;
};

const createConsentHandlers = ({
  storageKey,
  setConsentState,
  setHasStoredConsent,
}: Args) => {
  const onConsent = ({ cookie }: { cookie: CookieConsent.CookieValue }) =>
    persistAndEmitConsentFromCookie({
      cookie,
      storageKey,
      setConsentState,
      setHasStoredConsent,
    });

  const onFirstConsent = ({ cookie }: { cookie: CookieConsent.CookieValue }) =>
    persistAndEmitConsentFromCookie({
      cookie,
      storageKey,
      setConsentState,
      setHasStoredConsent,
    });

  const onChange = ({ cookie }: { cookie: CookieConsent.CookieValue }) =>
    persistAndEmitConsentFromCookie({
      cookie,
      storageKey,
      setConsentState,
    });

  return { onConsent, onFirstConsent, onChange };
};

export default createConsentHandlers;
